import { useCallback } from 'react';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import type { CareCreditPreapprovedDisclosureNavigationProps } from '../care-credit-preapproved-disclosure.types';

export const CareCreditPreapprovedDisclosureGenericNavigation = ({
  body: Body,
}: CareCreditPreapprovedDisclosureNavigationProps) => {
  const {
    setCareCreditMessageType,
    multiStep: { goPrevStep, goNextStep },
  } = useCollectPaymentMultiContext();

  const onGoBack = useCallback(() => {
    goPrevStep({ orStep: PAYMENT_MULTI_STEPS.paymentMethods });
  }, [goPrevStep]);

  const onCompleteStep = useCallback(() => {
    setCareCreditMessageType('pre-approved-link');
    goNextStep({ orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure });
  }, [goNextStep]);

  return <Body onGoBack={onGoBack} onCompleteStep={onCompleteStep} />;
};
